import React, { useState, useEffect } from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";

import SkeletonWrapper from '../../../NewProductList/components/SkeletonWrapper/SkeletonWrapper';
import { getPartner } from '../../../../lib/access.es6';
import TableInc from '../../../../shared-ui/TableInc';
import { formatDateLocale } from '../../../../lib/utils.es6';
import { fetchProductCurrency } from '../../../../hooks/useProductCurrency';


const Premiums = (props) => {
  const classes = useStyle();

  const [productCurrencies, setProductCurrencies] = useState({});

  const customerPremiums = props.premiums || [];

  useEffect(() => {
    const uniqueProductCodes = Array.from(
      new Set(
        customerPremiums
          .map(premiums => premiums.product_code)
          .filter(Boolean)
      )
    );

    uniqueProductCodes.forEach(productCode => {
      if (productCurrencies[productCode]) {
        return;
      }
      fetchProductCurrency(productCode).then(currency => {
        if (currency) {
          setProductCurrencies(prev => ({ ...prev, [productCode]: currency }));
        }
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerPremiums]);

  const fallbackCurrencyCode = getPartner().country.currency_code

  const tempArr = customerPremiums.map(premiums => {
    const currencyCode = productCurrencies[premiums.product_code] || fallbackCurrencyCode
    return {
      ...premiums,
      product_name:  premiums.product_name || "N/A",
      created_at:   formatDateLocale(premiums.created_at) || "N/A",
      amount_in_cents: currencyCode + " " + premiums.amount_in_cents / 100 || "N/A"
      }

  })

  if (props.loading) {
    return <SkeletonWrapper loading={props.loading} />
  }


  return (
    <>
      {
        customerPremiums.length > 0 ? (<>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} >
              <TableInc

                columns={[
                  {
                    title: 'Product Name', field: 'product_name'
                  },
                  {
                    title: 'Payment reference', field: 'reference', render: rowData => <>
                      {
                        rowData.reference || "N/A"
                      }
                    </>
                  },
                  {
                    title: 'Created at', field: 'created_at', render: rowData => <>
                      {
                        rowData.created_at || "N/A"
                      }
                    </>
                  },
                  {
                    title: 'Effected at', field: 'effected_at', render: rowData => <>
                      {
                        formatDateLocale(rowData.effected_at) || "N/A"
                      }
                    </>
                  },

                  {
                    title: 'Amount', field: 'amount_in_cents'
                  },


                ]}
                title="Premiums"
                data={
                  tempArr
                }
                options={{
                  pageSize: customerPremiums.length < 5
                  ? customerPremiums.length
                  : 5,
                  exportButton: true,
                  showTitle: false,
                }}

              />
            </Grid>
          </Grid>
        </>) : (<>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} >
              <div className={classes.policieswrapper}>
                <div className={classes.nodatafound}>
                  <p>No premiums found please add payments </p>
                </div>
              </div>
            </Grid>
          </Grid>

        </>)
      }



    </>
  )


}

export default Premiums